import * as Sentry from "@sentry/browser";

import type { AptConfig } from "./defs";

export const getAptConfig = (key: keyof AptConfig): string => {
  if (!window?.aptConfig?.[key]) {
    const error = `Missing aptConfig key ${key}`;
    Sentry.captureException(error);
    /**
     * Currently we only use aptConfig for metrics & feature flag tracking
     * As such, throwing here would break the app, which we should only do
     * if the props on aptConfig are _absolutely_ required for the app
     * to function
     */
    return "";
  }
  return window.aptConfig[key];
};

const prodUrls = ["get.afterpay.com", "get.clearpay.co.uk"];

export const isProd = prodUrls.includes(window?.location?.hostname);
export const isDev = process.env.NODE_ENV === "development";
export const MARQETAJS_URL = isProd
  ? "https://widgets.marqeta.com/marqetajs/1.1.0/marqeta.min.js"
  : "https://widgets-sandbox.marqeta.com/marqetajs/1.1.0/marqeta.min.js";

export const getEnv = (): "development" | "staging" | "production" => {
  if (isProd) {
    return "production";
  }
  if (isDev) {
    return "development";
  }
  return "staging";
};
